/* eslint react-hooks/rules-of-hooks: "warn" */
import { useStoreActions, useStoreState } from '@/store';
import { IUserInfoParams } from '@/store/models/user-info-model';

export const userGetUserInfo = () => {
    return useStoreActions((actions) => actions.userInfoModel.getUserInfo);
};

export const useUserInfoHelper = () => {
    const setUserInfo = useStoreActions((actions) => actions.userInfoModel.setUserInfo);
    const userInfo = useStoreState((state) => state.userInfoModel.userInfo) || undefined;

    const showUserInfo = () => {
        return userInfo;
    };

    const onSetUserInfo = (userInfo: IUserInfoParams) => {
        setUserInfo(userInfo);
    };

    return {
        showUserInfo,
        onSetUserInfo,
        setUserInfo,
        userInfo,
    };
};
